import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { finish } from "@api/courses/exams/fileBased/attempts/finish/path";
import { latest } from "@api/courses/exams/fileBased/attempts/latest/path";
import { fileBasedExamAttemptSubmissions } from "@/api/courses/exams/fileBased/attempts/submissions/path";

const pathBase = `/courses/:courseId/exams/file-based/:examId/attempts/`;
const pathById = `${pathBase}:attemptId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const attempt = {
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  finish,
  latest,
  fileBasedExamAttemptSubmissions,
} as const;
